import { Divider, DividerPosition } from 'omakase';
import { FunctionComponent } from 'react';
import { dividerThickMobile } from './formBlockCssDefs';

const MobileDivider: FunctionComponent<{ position?: DividerPosition }> = ({
  position,
  ...rest
}) => (
  <Divider
    data-testid="divider-testid-thick"
    css={dividerThickMobile}
    position={position}
    variant="thick"
    {...rest}
  />
);

export default MobileDivider;
